<template>
    <!--unit列表-->
    <div class="content">
        <div class="curr_btn">
            <Button type="primary" @click="add()">添加单元</Button>
        </div>
        <div class="curr_tab" v-model="listData">
            <Divider orientation="left">level1</Divider>
            <Table :loading="loading" border :columns="columns" :data="listData.list1"></Table>
            <Divider orientation="left">level2</Divider>
            <Table :loading="loading" border :columns="columns" :data="listData.list2"></Table>
            <Divider orientation="left">level3</Divider>
            <Table :loading="loading" border :columns="columns" :data="listData.list3"></Table>
            <Divider orientation="left">level4</Divider>
            <Table :loading="loading" border :columns="columns" :data="listData.list4"></Table>
        </div>
    </div>
</template>
<style scoped>
.content>div {
    padding: 10px 0;
}
</style>
<script>
import {
    Divider
} from 'iview';
import http from "../../libs/http.js"
import { mapGetters } from 'vuex'
export default {
    components: {
        Divider
    },
    data() {
        return {
            loading: false,
            listData:{},
            list: [],
            columns: [{
                    title: 'No.',
                    type: 'index',
                    align: 'center',
                },
                {
                    title: '英文主题',
                    key: 'eName',
                    align: 'center',
                },
                {
                    title: '中文主题',
                    key: 'name',
                    align: 'center',
                },

                {
                    title: '操作',
                    key: 'action',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                },
                                style: {
                                    marginRight: '2px'
                                },
                                on: {
                                    click: () => {
                                        this.add(params.row.id)
                                    }
                                }
                            }, '编辑单元'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                    disabled: this.getLimit == 1 || this.getLimit == 6 ? false : true
                                },
                                on: {
                                    click: () => {
                                        this.delete(params.row.id)
                                    }
                                }
                            }, '删除'),
                            h('ButtonGroup',{
                                style: {
                                    marginLeft: '20px'
                                },
                            }, [
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small',
                                        disabled: params.row == 1 ? true : false,
                                        icon: 'ios-arrow-up',
                                        ghost: true,
                                    },
                                    on: {
                                        click: () => {
                                            this.move(params.row, 0)
                                        }
                                    }
                                }),
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small',
                                        disabled: params.row == 1 ? true : false,
                                        icon: 'ios-arrow-down',
                                        ghost: true,
                                    },
                                    style: {
                                        marginRight: '4px'
                                    },
                                    on: {
                                        click: () => {
                                            this.move(params.row, 1)
                                        }
                                    }
                                }),
                            ]),

                        ]);
                    }
                }
            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        //获取unit列表
        getList() {
            let that = this;
            that.loading = true;
            http.post('/custom/unitInfo/list', {
                status: 0,
            }).then(res => {
                that.loading = false;
                that.listData = res

            })
        },
        // 点击添加/编辑unit事件
        add(id) {
            if (id) {
                this.$router.push({ path: 'editUnit', query: { id: id } })
            } else {
                this.$router.push({ path: 'editUnit' })
            }
        },
        //点击删除事件
        delete(id) {
            let that = this
            this.$Modal.confirm({
                title: '提示',
                content: '确定删除该单元?',
                onOk: () => {
                    http.post('/custom/unitInfo/del', {
                        id: id
                    }).then(res => {
                        if (res) {
                            that.getList()
                            that.$Message.success('删除成功');
                        }
                        
                    })
                }
            });
        },
        //上移/下移
        move(row, type) {
            this.loading = true
            http.post('/custom/unitInfo/move', {
                seq: row.seq,
                id: row.id,
                level: row.level,
                up: type
            }).then(res => {
                this.loading = false
                if (res) {
                    this.getList()
                }
            })
        }
    },
    computed: {
        ...mapGetters([
            'getLimit',
        ])
    },
}
</script>